import { useQuery, type QueryFunctionContext } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { UrlUtilities } from "src/http";
import { UserFeedbackType, type UserFeedbackDto } from "src/http/types";
import { queryKeys } from "../queryKeys";
import type { QueryParams } from "../utilities";
import { v4 as newGuid } from "uuid";

const useGetReceivedFeedback = (userId: string, queryParams?: QueryParams) => {
  // const { getAccessToken } = useAccessToken();

  async function getReceivedFeedbackRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.userFeedback.getReceivedFeedback>>): Promise<UserFeedbackDto[]> {
    // const accessToken = await getAccessToken();
    const [{ userId, queryParams }] = queryKey;

    const url = new URL(`${configuration.apiRootUrl}/userFeedback/${userId}`);
    UrlUtilities.appendQueryParams(url, queryParams);

    // const response = await fetch(url.href, {
    //   headers: {
    //     Authorization: `Bearer ${accessToken}`,
    //   },
    // });

    // if (!response.ok) {
    //   throw new FetchError(response);
    // }

    // return response.json();

    const results: UserFeedbackDto[] = [
      {
        feedbackGuid: newGuid(),
        title: "Received 1",
        type: UserFeedbackType.Peer,
        isDraft: false,
        isReviewedByRecipient: true,
        isReviewedInOneOnOne: true,
        givenByUser: {
          displayName: "Michael Wappel",
          userId: "12345",
        },
        submittedDateTimeUtc: "2026-04-26T10:00:00",
        createdDateTimeUtc: "2026-03-26T10:00:00",
      },
      {
        feedbackGuid: newGuid(),
        title: "Received 4",
        type: UserFeedbackType.Peer,
        isDraft: false,
        isReviewedByRecipient: true,
        isReviewedInOneOnOne: true,
        givenByUser: {
          displayName: "Alen Puaca",
          userId: "12345",
        },
        submittedDateTimeUtc: "2026-04-26T10:00:00",
        createdDateTimeUtc: "2026-03-26T10:00:00",
      },
      {
        feedbackGuid: newGuid(),
        title: "Received 2",
        type: UserFeedbackType.Performance,
        isDraft: false,
        isReviewedByRecipient: true,
        isReviewedInOneOnOne: false,
        givenByUser: {
          displayName: "Alen Puaca",
          userId: "12345",
        },
        submittedDateTimeUtc: "2026-03-26T09:15:00",
        createdDateTimeUtc: "2026-02-26T10:00:00",
      },
      {
        feedbackGuid: newGuid(),
        title: "Received 3",
        type: UserFeedbackType.SelfReflection,
        isDraft: true,
        isReviewedByRecipient: false,
        isReviewedInOneOnOne: false,
        givenByUser: {
          displayName: "Garrett Samm",
          userId: "12345",
        },
        submittedDateTimeUtc: "2026-04-28T14:32:00",
        createdDateTimeUtc: "2026-04-28T14:32:00",
      },
    ];

    return results;
  }

  return useQuery({
    queryKey: queryKeys.userFeedback.getReceivedFeedback(userId, queryParams),
    queryFn: getReceivedFeedbackRequest,
  });
};

export { useGetReceivedFeedback };
